import React, { Component } from 'react'
import { Button, Table, Modal, Spin, message, Upload, Icon, Select,Radio, Input, } from "antd"
import styled from "styled-components"
import UploadAPI from '@/API/saveDevice'
import Filter from '@/components/SaveDevice/Filter'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next';
import dayjs from 'dayjs'

const { Option } = Select;
const Div=styled.div`
  margin-bottom: 10px;
`

const UploadTable=styled(Table)`
  margin:0 20px;
`
const MyUpload=styled(Upload)`
  .ant-upload-list-item{
    margin-top:24px;
    height:auto;
    background-color:#F8FAFB;
    padding:14px;
    cursor:pointer;
    color:#2FC29B;
    .ant-upload-list-item-name{
      text-decoration:underline;
    }
    .ant-upload-list-item-info{
      background-color:inherit !important;
    }
  }
  .ant-upload-list-item-info .anticon-paper-clip,
  .ant-upload-list-item .anticon-close{
    margin-top:14px;
    margin-right:14px;
  }
`

const TemplateLink = styled(Button)`
  margin-right:20px;
`;

class SaveDevice extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      filter:{
        type:0
      },
      operatorList:[],
      productList:[],
      operator:"",
      // productName:"",
      uploadList:[],
      dialogShow:false,
      fileList:[],
      confirmLoading:false,
      pagination:{
        current:1,
        pageSize:10,
        total:0,
        showSizeChanger:true,
        size:'small',
        showTotal:(total)=>(this.props.t('Total items',{total:total}))
      },
      radioValue: 1,
      singelIMEI:''
    };
    this.agentColumns=[
      {
        title:this.props.t('Upload Date'),
        dataIndex:'time',
        render:(text)=>(dayjs(text).format('YYYY-MM-DD HH:mm:ss'))
      },
      {
        title:this.props.t('Total Devices'),
        dataIndex:'totalCount'
      },
      {
        title:this.props.t('Successful'),
        dataIndex:'succeedCount'
      },
      {
        title:this.props.t('Failed'),
        dataIndex:'failedCount'
      },
      {
        title:this.props.t('Uploaded By'),
        dataIndex:'userName'
      },
      {
        title:this.props.t('Carrier Code'),
        dataIndex:'operator'
      },
      {
        title:this.props.t('Model'),
        dataIndex:'productName'
      }
    ]
    this.operatorColumns=[
      {
        title:this.props.t('Upload Date'),
        dataIndex:'time',
        render:(text)=>(dayjs(text).format('YYYY-MM-DD HH:mm:ss'))
      },
      {
        title:this.props.t('Total Devices'),
        dataIndex:'totalCount'
      },
      {
        title:this.props.t('Successful'),
        dataIndex:'succeedCount'
      },
      {
        title:this.props.t('Failed'),
        dataIndex:'failedCount'
      },
      {
        title:this.props.t('Uploaded By'),
        dataIndex:'userName'
      },
      {
        title:this.props.t('Carrier Code'),
        dataIndex:'operator'
      },
      {
        title:this.props.t('Type'),
        dataIndex:'operateType',
        render:(text)=>(text?this.props.t("Delete"):this.props.t("Upload"))
      }
    ]
  }

  componentDidMount() {
    this.getUploadList()
    this.getProductList()
  }
  
  getColumns=()=>{
    const {filter}=this.state
    const {roleId}=this.props
    if(roleId==1||roleId==2){
      return filter.type?this.agentColumns:this.operatorColumns
    } else if(roleId==3){
      return this.operatorColumns;
    }else {
      return this.agentColumns;
    }
  }
  filterChange=(key,value)=>{
    let field={}
      field[key]=value
      this.setState(prevState=>({
        filter:{
          ...prevState.filter,
          ...field
        }
      }))
    this.setState({
      pagination:{
        current:1,
        pageSize:10,
        total:0,
        showSizeChanger:true,
        size:'small',
        showTotal:(total)=>(this.props.t('Total items',{total:total}))
      }
    },()=>{
      this.getUploadList()
    })
  }

  getUploadList=()=>{
    this.setState({loading:true})
    const {pagination}=this.state
    const {roleId}=this.props
    if(!roleId){
      return setTimeout(()=>{
        this.getUploadList()
      },500)
    }
    UploadAPI.getUploadList({pageIndex:pagination.current-1,pageSize:pagination.pageSize}).then((res)=>{
      this.setState((state)=>{
        return {uploadList:res.data,pagination:{...state.pagination,total:res.totalCount}}
      })
      this.setState({loading:false})
    })
  }
  
  handleTableChange=(pagination)=>{
    this.setState({
      pagination: pagination,
    },()=>{
      this.getUploadList()
    });
  }
  initDialog=()=>{
    this.setState({dialogShow:true,singelIMEI:''})
  }
  uploadInit=()=>{
    this.setState({
      operator:'',
      // productName:'',
      fileList:[],
      singelIMEI:''
    })
  }
  handleCancel=()=>{
    this.setState({
      dialogShow:false,
      fileList:[]
    })
  }
  handleOk=()=>{    
    // var {productName,fileList,radioValue,singelIMEI}=this.state
    var {fileList,radioValue,singelIMEI}=this.state
    var {t,roleId}=this.props
    var formData=new FormData() 
    // 代理商和多选
    const valid = roleId === 1 || roleId === 2 || roleId === 3
    if(valid && radioValue ===0){
      // if(!productName){
      //   return message.warning(t("Select a model."))
      // }
      if(!fileList.length){
        return message.warning(t("Upload an IMEI table."))
      }      
      // formData.append('productName',productName)
      formData.append('file',fileList[0])
      UploadAPI.agentUpload(formData).then((res)=>{
        if(!res.code){
          message.success(t("Uploaded successfully."))
          this.uploadInit()
          this.setState({dialogShow:false})
          this.getUploadList()
        }else{
          message.error(res.info)
        }
      }).catch(()=>{
        message.error(t("Upload failed."))
      })
    // 代理商和单选
    }else if(valid && radioValue ===1){
      // if(!productName){
      //   return message.warning(t("Select a model."))
      // }
      if(!singelIMEI){
        return message.warning(t("Please enter an IMEI."))
      }      
      // formData.append('productName',productName)
      formData.append('imei',singelIMEI)      
      UploadAPI.agentUploadSingle(formData).then((res)=>{
        if(!res.code){
          message.success(t("Uploaded successfully."))
          this.uploadInit()
          this.setState({dialogShow:false})
          this.getUploadList()
        }else{
          message.error(res.info)
        }
      }).catch(()=>{
        message.error(t("Upload failed."))
      })
      //运营商和仓库多选
    }
  }
  handleProductChange=(value)=>{
    this.setState({productName:value})
  }
  getProductList=()=>{
    UploadAPI.getProductList().then((res)=>{
      this.setState({productList:res})
    })
  }
  changeRadio = e => {    
    this.setState({radioValue: e.target.value})    
  };
  changeInput = e => {
    this.setState({singelIMEI: e.target.value});    
  }
  
  render() {
    const {uploadList,loading,pagination,dialogShow,fileList,productList} = this.state
    const { t } = this.props
    const {radioValue, singelIMEI} = this.state
    const props = {
      name: 'file',
      accept:'.xls,.xlsx,.csv',
      beforeUpload:(file)=>{
        this.setState({fileList:[file]})
        return false
      },
      onPreview(file){
        var aLink=document.createElement('a')
        var blob=new Blob([file])
        aLink.download=file.name
        aLink.href=URL.createObjectURL(blob)
        aLink.click()
      },
      onRemove:()=>{
        this.setState({fileList:[]})
      }
    }
    return (
      <div>
        <Filter filterChange={this.filterChange} initDialog={this.initDialog}></Filter>
        <Spin spinning={loading}>
          <UploadTable dataSource={uploadList} columns={this.getColumns()} pagination={pagination} rowKey="id" onChange={this.handleTableChange}></UploadTable>
        </Spin>
        {
          dialogShow&&(
            <Modal title={t('Import IMEI')} visible={dialogShow} onOk={this.handleOk} onCancel={this.handleCancel} okText={t('OK')}>
              {/* <Div>
                <Select placeholder={t("Select model")} style={{ width: 300 }} onChange={this.handleProductChange}>
                  {
                    productList.map((product)=>(
                      <Option value={product} key={product}>{product}</Option>
                    ))
                  }
                </Select>
              </Div> */}
              <div style={{ marginBottom: '10px' }}>
                <Radio.Group onChange={this.changeRadio} value={radioValue}>
                  <Radio value={1}>Single</Radio>
                  <Radio value={0}>Multiple</Radio>
                </Radio.Group>
              </div>
              { radioValue ? 
                <div>
                  <Input value={singelIMEI} onChange={this.changeInput} placeholder='Please enter an IMEI' style={{marginBottom:'10px'}}></Input>                                  
                </div>
                :
              <MyUpload {...props} fileList={fileList}>
                <div style={{ marginBottom: '10px' }}>
                <TemplateLink href={'/api/downloadTpl?type=0'} onClick={(e)=>{e.stopPropagation()}}>
                {t('Download Template(.xls)')}</TemplateLink>
                <TemplateLink href={'/api/downloadTpl?type=2'} onClick={(e)=>{e.stopPropagation()}}>
                {t('Download Template(.cvs)')}
                </TemplateLink>
                </div>
                <Button type="primary">
                  <Icon type="upload"></Icon>
                  {t('Import IMEI')}
                </Button>
              </MyUpload>
              }
            </Modal>
          )
        }
      </div>
    );
  }
}

const mapStateToProps=(state)=>{
  return {
    menus:state.menus,
    roleId:state.roleId
  }
}

export default connect(mapStateToProps)(withTranslation()(SaveDevice))
